import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { HorizontalLine, LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold, Subtitle } from "capitalrx-components-2.0/lib/typography";

import { DrugPrices } from "@/App/api/drug";
import { ThemedButton } from "@/App/components";

const VerticalDivider = () => {
  return <span style={{ display: "inline", color: "#313E48" }}>&#124;</span>;
};

interface DrugHeaderProps {
  onBackPressed: () => void;
  isLoadingDrugPrices: boolean;
  drugPrices: DrugPrices;
}

export const DrugHeader = ({ onBackPressed, isLoadingDrugPrices, drugPrices }: DrugHeaderProps) => {
  const { t: translate } = useTranslation();
  const [searchParams] = useSearchParams();
  const dosageForm = searchParams.get("dosage_form");
  const dosage = searchParams.get("dosage");
  const quantity = searchParams.get("quantity");
  const daysSupply = searchParams.get("days_supply");

  return (
    <LoadingGroup loading={isLoadingDrugPrices}>
      <Stack spacing="small">
        <Shelf>
          <ThemedButton testId="go-back" onClick={onBackPressed} appearance="text" icon="arrow-left">
            {translate("FIND_BEST_PRICE.findBestPriceResultsPage.back")}
          </ThemedButton>
          <Shelf.Spacer />
        </Shelf>
        <LoadingGroup.Placeholder fallback={<LoadingSkeleton style={{ height: 36, width: 120 }} />}>
          <Subtitle testId="drug-name">{drugPrices?.prices[0]?.drug?.drug_name}</Subtitle>
        </LoadingGroup.Placeholder>
        <LoadingGroup.Placeholder fallback={<LoadingSkeleton style={{ height: 24, width: 220 }} />}>
          <Shelf spacing="small">
            <Body>
              <Semibold>{dosageForm}</Semibold>
            </Body>
            <VerticalDivider />
            <Body>
              <Semibold>{dosage}</Semibold>
            </Body>
            <VerticalDivider />
            <Body>
              <Semibold>{quantity}</Semibold>
            </Body>
            <VerticalDivider />
            <Body>
              <Semibold>
                {daysSupply} {translate("FIND_BEST_PRICE.findBestPriceResultsPage.daysSupply")}
              </Semibold>
            </Body>
            <Shelf.Spacer />
          </Shelf>
        </LoadingGroup.Placeholder>
      </Stack>
      <Shelf.Spacer />
      <HorizontalLine />
    </LoadingGroup>
  );
};
